import { createAuthProvider } from 'shared-ui';
import { TOKEN_KEY, USER_KEY } from '../constants';
import { authApi } from '../services/api';

export interface CircleUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  preferredLanguage?: string;
}

async function loginAndGetSession(
  email: string,
  password: string
): Promise<{ token: string; user: CircleUser } | null> {
  const data = await authApi.login(email, password);
  const token = data?.tokens?.personal ?? data?.tokens?.staff ?? data?.token;
  const u = data?.user ?? data?.account;
  if (!token || !u) return null;
  const user: CircleUser = {
    id: u.id,
    email: u.email ?? email,
    firstName: u.firstName ?? email.split('@')[0],
    lastName: u.lastName ?? '',
  };
  return { token, user };
}

async function fetchUserFromToken(): Promise<CircleUser | null> {
  const me = await authApi.me();
  const u = me?.user;
  if (!u?.id || !u?.email) return null;
  return {
    id: u.id,
    email: u.email,
    firstName: u.firstName ?? u.email.split('@')[0],
    lastName: u.lastName ?? '',
    preferredLanguage: u.preferredLanguage ?? 'en',
  };
}

const { AuthProvider, useAuth } = createAuthProvider<CircleUser>({
  tokenKey: TOKEN_KEY,
  userKey: USER_KEY,
  loginAndGetSession,
  consumeHashToken: { fetchUser: fetchUserFromToken },
});

export { AuthProvider, useAuth };
